import { useEffect, useState, useRef } from "react";
/**
* Custom React hook to manage the open/close state of a dropdown component.
*
* - Provides a ref to attach to the dropdown element.
* - Closes the dropdown automatically when clicking outside the referenced element.
* - Tracks whether the dropdown is currently open.
*
* @returns {{
*   ref: React.RefObject<HTMLDivElement>; // Ref to attach to the dropdown container
*   isOpen: boolean;                      // Current open state of the dropdown
*   setIsOpen: (open: boolean) => void;   // Function to manually toggle dropdown state
* }}
*/
export const useDropdown = () => {
    const ref = useRef<HTMLDivElement>(null); // Ref for the dropdown
    const [isOpen, setIsOpen] = useState<boolean>(false); // Handle dropdown toggle toggle
    // Handle click outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    return { ref, isOpen, setIsOpen }
}